import React from 'react';
import CustomerApi from 'api/customer';
import Loader from 'components/loader';
import events from 'lib/events';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class CustomerTools extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    showDate: true,
    searching: false,
    results: null,
  };

  beginSearch = () => {
    this.setState({searching: true});
    if (this.state.showDate) {
      CustomerApi.inactiveCustomersByLastAnalysis(this.dateRange.value)
        .then(count => this.setState({results: count, searching: false}));
    } else {
      CustomerApi.inactiveCustomersBySystem()
        .then(count => this.setState({results: count, searching: false}));
    }
  };

  markInactive = () => {
    if (this.state.showDate) {
      CustomerApi.inactiveCustomersByLastAnalysis(this.dateRange.value, true)
        .then(count => {
          events.publish('success.user', {
            message: <FormattedMessage id='tools.marked.inactive.count' values={{count: <span className='blue'>{count}</span>}} />,
          });
        });
    } else {
      CustomerApi.inactiveCustomersBySystem(true)
        .then(count => {
          events.publish('success.user', {
            message: <FormattedMessage id='tools.marked.inactive.count' values={{count: <span className='blue'>{count}</span>}} />,
          });
        });
    }
  };

  optionChange = () => {
    this.setState({showDate: this.radioAnalysis.checked});
  };

  resultsTile = () => {
    if (this.state.searching) {
      return <div className='col-md-6'
                  style={{height: '120px'}}>
        <Loader loaded={false}/>
      </div>;
    }

    if (this.state.results !== null) {
      return <div className='col-md-6'>
        <div className='panel panel-default'>
          <div className='panel-body'
               style={{height: '88px'}}>
            <span className='pull-right dim'>
              <FormattedMessage id='general.step.range'
                                values={{n: 2, total: 2}}/>
            </span>
            <label>
              <FormattedMessage id='tools.found.inactive.count'
                                values={{count: <span className='b'
                                                      style={{color: '#061f5c'}}>{this.state.results}</span>}} />
            </label>
            <p>
              <FormattedMessage id = 'tools.mark.inactive.confirm' values={{count: this.state.results}} />
            </p>
          </div>
          <div className='panel-footer'>
            <button type='button'
                    className='btn btn-primary'
                    onClick={this.markInactive}>
              <FormattedMessage id='tools.mark.inactive.button' values={{count: this.state.results}} />
            </button>
          </div>
        </div>
      </div>;
    }

    return <div className='col-md-6'
                style={{display: 'table', height: '140px'}}>
      <div style={{display: 'table-cell', verticalAlign: 'middle'}}>
        <div className='col-md-1'>
          <i className='bl bl-help-circle blue fa-lg'/>
        </div>
        <div className='col-md-11'>
          <p><FormattedMessage id="tools.begin.inactive.criteria"/></p>
          <p><FormattedMessage id="tools.search.inactive.instructions"
                               values={{button: <span className='blue'><FormattedMessage id="tools.search.inactive"/></span>}}/>
          </p>
          {this.state.showDate ? <p><FormattedMessage id="tools.customers.last.analysis"/></p> : null}
        </div>
      </div>
    </div>;
  };

  render() {
    let dateField;

    if (this.state.showDate) {
      dateField =
        <select ref={r => this.dateRange = r}
                className='form-control pull-left'
                style={{width: '45%'}}>
          <option value={12}>
            <FormattedMessage id='general.months.ago'
                              values={{n: 12}}/>
          </option>
          <option value={18}>
            <FormattedMessage id='general.months.ago'
                              values={{n: 18}}/>
          </option>
          <option value={24}>
            <FormattedMessage id='general.months.ago'
                              values={{n: 24}}/>
          </option>
        </select>;
    }

    return <div>
      <h2><FormattedMessage id="tools.inactive.customers"/></h2>
      <p>
        <FormattedMessage id="tools.set.criteria.message"
                          values={{reportLink: <a href='#reports'
                                                  className='b underline'><FormattedMessage id="reports.title"/></a>}}/>
      </p>
      <br/>
      <div className='row'>
        <div className='col-md-6'>
          <div className='panel panel-default'>
            <div className='panel-body'>
              <span className='pull-right dim'>
                <FormattedMessage id='general.step.range'
                                    values={{
                                      n: 1,
                                      total: 2,
                                    }}/>
              </span>
              <label><FormattedMessage id="tools.set.inactive.criteria"/></label>
              <div className='form-group'>
                <label className='radio-inline'>
                  <input type='radio'
                         name='criteria'
                         ref={r => this.radioAnalysis = r}
                         defaultChecked={true}
                         onClick={this.optionChange}/> <FormattedMessage id="general.last.analysis.date"/>
                </label>
                <label className='radio-inline'>
                  <input type='radio'
                         name='criteria'
                         ref={r => this.radioSystems = r}
                         defaultChecked={false}
                         onClick={this.optionChange}/> <FormattedMessage id="tools.no.systems.maintained"/>
                </label>
              </div>
            </div>
            <div className='panel-footer text-right'>
              {dateField}
              <button type='button'
                      className='btn btn-primary'
                      onClick={this.beginSearch}><FormattedMessage id="tools.search.inactive"/></button>
            </div>
          </div>
        </div>
        {this.resultsTile()}
      </div>
    </div>;
  }
}

export default injectIntl(CustomerTools);
